(function () {
  if (!window.QUIZ_CTA) return;

  if (window.location.pathname.startsWith('/blogs/')) return;

  const SELECTORS = [
    'a[data-quiz-cta]',
    'a[href*="/pages/quiz"]',
    'a[href*="/retake-quiz"]'
  ].join(',');

  function isQuizLink(a) {
    if (!a) return false;
    if (a.dataset.quizCta !== undefined) return true;
    const href = a.getAttribute('href') || '';
    if (href.indexOf('/pages/quiz') > -1 || href.indexOf('/retake-quiz') > -1) return true;

    const txt = (a.textContent || '').toLowerCase();
    return txt.indexOf('quiz') > -1;
  }

  function applyQuizCta(a) {
    if (!a) return;

    // Opt-out: which element does NOT want to be edited
    if (a.dataset.noQuizAutofix !== undefined) {
      a.dataset.quizProcessed = '1';
      return;
    }

    if (a.dataset.quizProcessed === '1') return; // idempotent

    if (!isQuizLink(a)) return;

    // Overwrite link
    a.setAttribute('href', window.QUIZ_CTA.href);

    // Override label — if you want to keep the HTML inside (icon/span), add data-keep-html
    if (!a.dataset.keepHtml) {
      a.textContent = window.QUIZ_CTA.label;
    } else {
      // Replace the first text node, keep the icon/span
      for (let i = 0; i < a.childNodes.length; i++) {
        const n = a.childNodes[i];
        if (n.nodeType === 3) { n.nodeValue = window.QUIZ_CTA.label; break; }
      }
    }

    a.dataset.quizProcessed = '1';
  }

  function scan(root) {
    const scope = root || document;
    const nodes = scope.querySelectorAll(SELECTORS);
    nodes.forEach ? nodes.forEach(applyQuizCta) : Array.prototype.forEach.call(nodes, applyQuizCta);
  }

  // Run as soon as possible
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  // Capture dynamic DOM (carousel, sections, third-party apps, etc.)
  const mo = new MutationObserver(function (muts) {
    for (let i = 0; i < muts.length; i++) { // Đổi const thành let
      const m = muts[i];
      if (!m.addedNodes) continue;
      for (let j = 0; j < m.addedNodes.length; j++) { // Đổi const thành let
        const node = m.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('a')) applyQuizCta(node);

        scan(node);
      }
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true });

  // Safety net: fix href right before navigation
  document.addEventListener('click', function (e) {
    const a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a) return;

    if (a.dataset.noQuizAutofix !== undefined) {
      a.dataset.quizProcessed = '1';
      return;
    }

    if (isQuizLink(a)) {
      a.setAttribute('href', window.QUIZ_CTA.href);
      if (!a.dataset.keepHtml) a.textContent = window.QUIZ_CTA.label;
      a.dataset.quizProcessed = '1';
    }
  }, true);

  // Theme Editor support (sections load/select)
  document.addEventListener('shopify:section:load', function () { scan(document); });
  document.addEventListener('shopify:section:select', function () { scan(document); });
})();
